var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('ProductCard',{attrs:{"product":_vm.product,"isAdmin":_vm.isAdmin,"daily-purchase-limit-amount":_vm.dailyPurchaseLimitAmount,"hot-products-disclaimer":_vm.hotProductsDisclaimer,"target-from-id":'productCardGridViewCard',"payment_methods":_vm.payment_methods}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }